import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { OrderSummaryContexts } from '../../constants/AppConstants';
import Order from '../../records/Order';
import OrderTrip from '../../records/order/Trip';

import SeasonTrip from './SeasonTrip';
import Trip from './Trip';

export default function FareOnlyTrip (props) {
    const orderTrip = props.orderTrip;

    if (!orderTrip.hasFareOnlyFare()) {
        return null;
    }

    if (orderTrip.getFareOnlyFare().isSeason()) {
        return <SeasonTrip { ...props } isFareOnly />;
    }

    return <Trip { ...props } isFareOnly />;
}

FareOnlyTrip.propTypes = {
    index: PropTypes.number.isRequired,
    order: PropTypes.instanceOf(Order).isRequired,
    orderTrip: PropTypes.instanceOf(OrderTrip).isRequired,
    open: PropTypes.bool,
    isLocked: PropTypes.bool,
    isLoggedIn: PropTypes.bool,
    context: PropTypes.oneOf(_.values(OrderSummaryContexts)),
};

FareOnlyTrip.defaultProps = {
    open: false,
    isLocked: false,
    isLoggedIn: false,
    context: null,
};
